import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import axios from 'axios';

// @mui
import { styled } from '@mui/material/styles';

import FreePlan from './plan_component/FreePlan';
import BasicPlan from './plan_component/BasicPlan';
import ProPlan from './plan_component/ProPlan';

const Div = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  // alignItems:'center',
  flex: 1,
  alignItems: 'stretch',
}));

const ContentDiv = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const FlexDiv = styled('div')(({ theme }) => ({
  padding: '80px',
  display: 'flex',
  backgroundColor: 'white',
  borderRadius: '20px',
  boxShadow: '0 0 2px 0 rgb(145 158 171 / 20%), 0 12px 24px -4px rgb(145 158 171 / 12%)',
}));

const ButtonDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const PreButton = styled('button')(({ theme }) => ({
  width: '160px',
  padding: '15px',
  backgroundColor: 'white',
  border: 'solid 1px #ddd',
  borderRadius: '5px',
  fontSize: 'larger',
  marginRight: 10,
}));

const PayButton = styled('button')(({ theme }) => ({
  width: '-webkit-fill-available',
  padding: '15px',
  backgroundColor: '#1a9ef8',
  border: 'solid 1px #1a9ef8',
  borderRadius: '5px',
  fontSize: 'larger',
  color: 'white',
}));

const INPUT = styled('input')(({ theme }) => ({
  width: 600,
  height: 60,
  padding: 10,
  marginTop: 30,
  fontSize: 'large',
}));

const H2 = styled('h2')(({ theme }) => ({
  fontSize: '2em',
}));

const FORM = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export default function MakeGroupName({ parentFunction }) {
  const navigate = useNavigate();
  const gotoLicencePage = () => {
    navigate('/license', { replace: true });
  };

  // ----------------------------------------------------------------------

  useEffect(() => {
    if (!sessionStorage.getItem('login_info')) {
      alert('로그인 후 이용 가능합니다.');
      navigate('/login', { replace: true });
    } else if (!sessionStorage.getItem('select_plan')) {
      alert('선택된 라이센스가 없습니다.');
      navigate('/license', { replace: true });
    }
  }, []);

  // ---------------------------------------------------------------------

  const { register, handleSubmit } = useForm();
  const onSubmit = (Data) => {
    // console.log('data', Data.org_name)
    if (Data.org_name !== '') {
      CheckGroupName(Data.org_name.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/gi, ''));
    } else {
      alert('그룹명을 입력하세요.');
    }
  };

  // ----------------------------------------------------------------------

  function CheckGroupName(name) {
    const userToken = JSON.parse(sessionStorage.getItem('login_info')).user_token;
    // console.log('userToken', userToken)

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/user/org-check/${name}`)
      .then((response) => {
        // console.log('그룹이름 중복 확인', response.data);

        if (response.data[0].result === 'available') {
          parentFunction(name);
          sessionStorage.setItem('org_name', name);
        } else {
          alert('이미 사용중인 그룹명 입니다. 다른 그룹명을 사용해 주세요.');
        }
      })
      .catch((response) => {
        console.log('그룹 중복 axios 에러 응답', response);
      });
  }

  // const onKeypress = (e) => {
  //   if(e.key === 'Enter'){
  //     handleSubmit(onSubmit)
  //   }
  // }

  return (
    <>
      <Div>
        <ContentDiv>
          <H2 style={{ marginBottom: '10px' }}>
            프로그램을 이용 할 그룹을 만들어주세요.
            <br /> 그룹에 포함 된 구성원은 무료로 사용 할 수 있어요.
          </H2>
          {sessionStorage.getItem('select_plan') === 'Basic' && sessionStorage.getItem('login_info') ? (
            <BasicPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'pro' && sessionStorage.getItem('login_info') ? (
            <ProPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'free' && sessionStorage.getItem('login_info') ? (
            <FreePlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'Basic_new' && sessionStorage.getItem('login_info') ? (
            <BasicPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'pro_new' && sessionStorage.getItem('login_info') ? (
            <ProPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : null}
        </ContentDiv>

        <FlexDiv>
          <FORM name="user_post" onSubmit={handleSubmit(onSubmit)}>
            <div>
              <H2>그룹 만들기</H2>

              <div>
                <INPUT type="text" {...register('org_name')} placeholder="그룹명을 입력해주세요." />
                <p style={{ color: '#1a9ef8', marginTop: 10 }}>그룹명은 한글/영어/숫자만 사용 가능해요.</p>
              </div>
            </div>
            <ButtonDiv>
              <PreButton
                type="button"
                onClick={() => {
                  gotoLicencePage();
                }}
              >
                이전
              </PreButton>
              <PayButton type="submit">구독하기</PayButton>
            </ButtonDiv>
          </FORM>
        </FlexDiv>
      </Div>
    </>
  );
}
